import {
	useEffect
}from "react"
import {
	Form, Modal, Popconfirm
}from "antd"
import CustomButton from "../../../components/CustomButton"
import CustomUpload from "../../../components/CustomUpload"

const AddWeightsFromFileModal = ({ visible, setVisible, getExampleFile, upload, isSending, changed }) => {
	const [form] = Form.useForm()

	useEffect(() => {
		if (changed)
			handleCancel()
	}, [changed])

	const createFromFile = () => {
		form.validateFields().then(values => {
			const data = new FormData()
			values.file?.forEach((src) => {
				data.append("File", src.originFileObj)
			})
			upload(data)
		})
	}

	const handleCancel = () => {
		setVisible(false)
		form.resetFields()
	}

	const normFile = (e) => {
		if (Array.isArray(e))
		  return e
		return e?.fileList
	  }

	return (
		<Modal
			className="mat-character"
			footer={ (
				<Popconfirm
					cancelText="Нет"
					okText="Да"
					placement="left"
					title="Внимание! Удельные веса, отсутствующие в файле, но присутствующие в классификаторе, будут удалены из него. Вы уверены, что хотите загрузить файл?"
					onCancel={ (e) => {
						e.preventDefault()
						return null
					} }
					onConfirm={ (e) => {
						e.preventDefault()
						createFromFile()
					} }
				>
					<CustomButton
						className="save-btn"
						loading={ isSending }
					>
						Сохранить
					</CustomButton>
				</Popconfirm>
			) }
			title="Обновление каталога-классификатора"
			visible={ visible }
			width={ 1000 }
			onCancel={ handleCancel }
		>
			<Form
				labelWrap
				className="mat-character-form"
				form={ form }
			>
				<Form.Item>
					<CustomButton
						onClick={ () => {
							getExampleFile()
						} }
					>
            Выгрузить шаблон файла для заполнения
					</CustomButton>
				</Form.Item>
				<Form.Item
					getValueFromEvent={ normFile }
					label="Загрузочный файл"
					name="file"
					rules={ [
						{ required : true,
							message  : "Пожалуйста, добавьте файл!" }
					] }
					valuePropName="fileList"
				>
					<CustomUpload
						isExcel
						maxCount={ 1 }
					/>
				</Form.Item>
			</Form>
		</Modal>
	)
}

export default AddWeightsFromFileModal